import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { TYPEOF } from '../../constants';
import Utils from '../../utils';
var FormValidator = /*#__PURE__*/function (_Component) {
  function FormValidator() {
    var _this;
    _classCallCheck(this, FormValidator);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormValidator, [].concat(_args));
    _this.state = {
      data: {},
      valid: {},
      warm: false,
      complete: false
    };
    _this.__refresh = function () {
      var m_data = {};
      var m_valid = {};
      if (typeof _this.props.schema === TYPEOF.OBJECT) {
        for (var _i = 0, _Object$entries = Object.entries(_this.props.schema); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          m_data[key] = '';
          m_valid[key] = _this.validate(key, '');
          if (key == 'cardType' && m_data[key] == '') {
            m_data[key] = 'visa';
            m_valid[key] = _this.validate(key, 'true');
          }
        }
      }
      _this._deep_state_merge_('data', m_data);
      _this._deep_state_merge_('valid', m_valid);
    };
    /**
     * @param {String} mergeInto state obj to merge keys into`
     * @param {Object} newData Keys to merge in
     */
    _this._deep_state_merge_ = function (mergeInto, newData) {
      _this.setState(_defineProperty({}, mergeInto, _objectSpread(_objectSpread({}, _this.state[mergeInto]), newData)));
    };
    _this.dataChangeHandle = function (key, isCheckbox) {
      if (isCheckbox === undefined || isCheckbox === null || isCheckbox === false) {
        return function (event) {
          var newVal = event.target.value;
          _this._deep_state_merge_('valid', _defineProperty({}, key, _this.validate(key, newVal)));
          _this._deep_state_merge_('data', _defineProperty({}, key, newVal));
        };
      }
      return function (event) {
        var newVal = !_this.state.data[key];
        _this._deep_state_merge_('valid', _defineProperty({}, key, _this.validate(key, newVal)));
        _this._deep_state_merge_('data', _defineProperty({}, key, newVal));
      };
    };
    _this.newDataChangeHandle = function (args) {
      var key = args.key,
        value = args.value,
        validated = args.validated;
      _this._deep_state_merge_('valid', _defineProperty({}, key, _this.validate(key, value)));
      _this._deep_state_merge_('data', _defineProperty({}, key, value));
    };
    _this.validate = function (key, value) {
      if (typeof _this.props.schema === TYPEOF.OBJECT) {
        return _this.props.schema[key](value, _this.state.data);
      }
      return false;
    };
    _this.submitHandle = function (event) {
      if (event) {
        event.preventDefault();
      }
      var rval = _this._checkValidation();
      if (rval) {
        if (typeof _this.props.onSubmit === TYPEOF.FUNCTION) {
          _this.props.onSubmit(_this.state.data);
        }
      } else if (typeof _this.props.onValidationFailed === TYPEOF.FUNCTION) {
        _this.props.onValidationFailed();
      }
    };
    _this._checkValidation = function () {
      var rval = true;
      for (var _i2 = 0, _Object$entries2 = Object.entries(_this.state.valid); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          key = _Object$entries2$_i[0],
          value = _Object$entries2$_i[1];
        if (value == false) {
          rval = false;
        }
      }
      return rval;
    };
    return _this;
  }
  _inherits(FormValidator, _Component);
  return _createClass(FormValidator, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (Utils.quickObjectComparision(prevState.valid, this.state.valid) === false) {
        var rval = this._checkValidation();
        if (rval !== this.state.complete) {
          this.setState({
            complete: rval
          });
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.__refresh();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.warm === false) {
        this.setState({
          warm: true
        });
        return null;
      }
      return this.props.render({
        data: this.state.data,
        valid: this.state.valid,
        complete: this.state.complete,
        dataChangeHandleFactory: this.dataChangeHandle,
        newDataChangeHandle: this.newDataChangeHandle,
        submitHandle: this.submitHandle
      });
    }
  }]);
}(Component);
export { FormValidator as default };